import type { DriverBreakStatus, DriverBreakSourceType } from '@/backend/market'

export class DriverBreakEntity {
  id?: string
  driverId?: number
  driverFullName?: string | null
  driverAvatarImagePath?: string | null
  driverRegionId?: number
  requestedByUserId?: string
  approvedByUserId?: string | null
  rejectedByUserId?: string | null
  startAt?: string
  endAt?: string
  reason?: string | null
  status?: DriverBreakStatus
  source?: DriverBreakSourceType
  reviewNotes?: string | null
  attachmentImagePath?: string | null
  canceledAt?: string | null
  completedAt?: string | null
  createdAt?: string
  updatedAt?: string
}
